import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
export const InvoiceV2Api = {
  Create: {
    useQuery: (dto: server.dto.CreateInvoiceV2Instruction, opts: UseQueryOptions<server.dto.ApiResponseWrapper<number>>) => useQuery({
      queryKey: ["InvoiceV2.Create", dto],
      queryFn: () => window.CoreApi.InvoiceV2.Create(dto).then(r => r.data),
      ...opts
    }),
    getCacheKey: (dto: server.dto.CreateInvoiceV2Instruction) => ["InvoiceV2.Create", dto]
  }, 
  Update: {
    useQuery: (dto: server.dto.UpdateInvoiceV2Instruction, opts: UseQueryOptions<server.dto.ApiResponse>) => useQuery({
      queryKey: ["InvoiceV2.Update", dto],
      queryFn: () => window.CoreApi.InvoiceV2.Update(dto).then(r => r.data),
      ...opts
    }),
    getCacheKey: (dto: server.dto.UpdateInvoiceV2Instruction) => ["InvoiceV2.Update", dto]
  }, 
  GetSidePanelData: {
    useQuery: (invoiceId: number, opts: UseQueryOptions<server.dto.ApiResponseWrapper<server.dto.InvoiceV2SidePanelData>>) => useQuery({
      queryKey: ["InvoiceV2.GetSidePanelData", invoiceId],
      queryFn: () => window.CoreApi.InvoiceV2.GetSidePanelData(invoiceId).then(r => r.data),
      ...opts
    }),
    getCacheKey: (invoiceId: number) => ["InvoiceV2.GetSidePanelData", invoiceId]
  }, 
  MakeCredit: {
    useQuery: (dto: server.dto.MakeCreditInvoiceV2Instruction, opts: UseQueryOptions<server.dto.ApiResponseWrapper<number>>) => useQuery({
      queryKey: ["InvoiceV2.MakeCredit", dto],
      queryFn: () => window.CoreApi.InvoiceV2.MakeCredit(dto).then(r => r.data),
      ...opts
    }),
    getCacheKey: (dto: server.dto.MakeCreditInvoiceV2Instruction) => ["InvoiceV2.MakeCredit", dto]
  }, 
  ChangeToDraftStage: {
    useQuery: (invoiceId: number, opts: UseQueryOptions<server.dto.ApiResponse>) => useQuery({
      queryKey: ["InvoiceV2.ChangeToDraftStage", invoiceId],
      queryFn: () => window.CoreApi.InvoiceV2.ChangeToDraftStage(invoiceId).then(r => r.data),
      ...opts
    }),
    getCacheKey: (invoiceId: number) => ["InvoiceV2.ChangeToDraftStage", invoiceId]
  }, 
  ChangeToReviewStage: {
    useQuery: (invoiceId: number, opts: UseQueryOptions<server.dto.ApiResponse>) => useQuery({
      queryKey: ["InvoiceV2.ChangeToReviewStage", invoiceId],
      queryFn: () => window.CoreApi.InvoiceV2.ChangeToReviewStage(invoiceId).then(r => r.data),
      ...opts
    }),
    getCacheKey: (invoiceId: number) => ["InvoiceV2.ChangeToReviewStage", invoiceId]
  }, 
  GetPreChangeToOutstandingInfo: {
    useQuery: (invoiceId: number, opts: UseQueryOptions<server.dto.ApiResponseWrapper<server.dto.PreChangeToOutstandingInfo>>) => useQuery({
      queryKey: ["InvoiceV2.GetPreChangeToOutstandingInfo", invoiceId],
      queryFn: () => window.CoreApi.InvoiceV2.GetPreChangeToOutstandingInfo(invoiceId).then(r => r.data),
      ...opts
    }),
    getCacheKey: (invoiceId: number) => ["InvoiceV2.GetPreChangeToOutstandingInfo", invoiceId]
  }, 
  ChangeToOutstanding: {
    useQuery: (dto: server.dto.ChangeInvoiceV2ToOutstandingInstruction, opts: UseQueryOptions<server.dto.ApiResponse>) => useQuery({
      queryKey: ["InvoiceV2.ChangeToOutstanding", dto],
      queryFn: () => window.CoreApi.InvoiceV2.ChangeToOutstanding(dto).then(r => r.data),
      ...opts
    }),
    getCacheKey: (dto: server.dto.ChangeInvoiceV2ToOutstandingInstruction) => ["InvoiceV2.ChangeToOutstanding", dto]
  }, 
  DownloadPdf: {
    useQuery: (invoiceId: number, fileName: string, inline: boolean, opts: UseQueryOptions<any>) => useQuery({
      queryKey: ["InvoiceV2.DownloadPdf", invoiceId, fileName, inline],
      queryFn: () => window.CoreApi.InvoiceV2.DownloadPdf(invoiceId, fileName, inline).then(r => r.data),
      ...opts
    }),
    getCacheKey: (invoiceId: number, fileName: string, inline: boolean) => ["InvoiceV2.DownloadPdf", invoiceId, fileName, inline]
  }, 
  PreviewDocument: {
    useQuery: (invoiceId: number, opts: UseQueryOptions<any>) => useQuery({
      queryKey: ["InvoiceV2.PreviewDocument", invoiceId],
      queryFn: () => window.CoreApi.InvoiceV2.PreviewDocument(invoiceId).then(r => r.data),
      ...opts
    }),
    getCacheKey: (invoiceId: number) => ["InvoiceV2.PreviewDocument", invoiceId]
  }, 
  AccountingSoftwareResend: {
    useQuery: (invoiceId: number, opts: UseQueryOptions<server.dto.ApiResponse>) => useQuery({
      queryKey: ["InvoiceV2.AccountingSoftwareResend", invoiceId],
      queryFn: () => window.CoreApi.InvoiceV2.AccountingSoftwareResend(invoiceId).then(r => r.data),
      ...opts
    }),
    getCacheKey: (invoiceId: number) => ["InvoiceV2.AccountingSoftwareResend", invoiceId]
  }, 
  ListParticipants: {
    useQuery: (dto: server.dto.ListInvoiceParticipantInstruction, opts: UseQueryOptions<server.dto.ApiResponseWrapper<server.dto.InvoiceParticipant[]>>) => useQuery({
      queryKey: ["InvoiceV2.ListParticipants", dto],
      queryFn: () => window.CoreApi.InvoiceV2.ListParticipants(dto).then(r => r.data),
      ...opts
    }),
    getCacheKey: (dto: server.dto.ListInvoiceParticipantInstruction) => ["InvoiceV2.ListParticipants", dto]
  }, 
  AddParticipant: {
    useQuery: (dto: server.dto.AddInvoiceParticipantInstruction, opts: UseQueryOptions<server.dto.ApiResponseWrapper<number>>) => useQuery({
      queryKey: ["InvoiceV2.AddParticipant", dto],
      queryFn: () => window.CoreApi.InvoiceV2.AddParticipant(dto).then(r => r.data),
      ...opts
    }),
    getCacheKey: (dto: server.dto.AddInvoiceParticipantInstruction) => ["InvoiceV2.AddParticipant", dto]
  }, 
  UpdateParticipant: {
    useQuery: (dto: server.dto.UpdateInvoiceParticipantInstruction, opts: UseQueryOptions<server.dto.ApiResponse>) => useQuery({
      queryKey: ["InvoiceV2.UpdateParticipant", dto],
      queryFn: () => window.CoreApi.InvoiceV2.UpdateParticipant(dto).then(r => r.data),
      ...opts
    }),
    getCacheKey: (dto: server.dto.UpdateInvoiceParticipantInstruction) => ["InvoiceV2.UpdateParticipant", dto]
  }, 
  DeleteParticipant: {
    useQuery: (dto: server.dto.DeleteInvoiceParticipantInstruction, opts: UseQueryOptions<server.dto.ApiResponse>) => useQuery({
      queryKey: ["InvoiceV2.DeleteParticipant", dto],
      queryFn: () => window.CoreApi.InvoiceV2.DeleteParticipant(dto).then(r => r.data),
      ...opts
    }),
    getCacheKey: (dto: server.dto.DeleteInvoiceParticipantInstruction) => ["InvoiceV2.DeleteParticipant", dto]
  }, 
  ResendParticipantEmail: {
    useQuery: (dto: server.dto.ResendParticipantEmailInstruction, opts: UseQueryOptions<server.dto.ApiResponse>) => useQuery({
      queryKey: ["InvoiceV2.ResendParticipantEmail", dto],
      queryFn: () => window.CoreApi.InvoiceV2.ResendParticipantEmail(dto).then(r => r.data),
      ...opts
    }),
    getCacheKey: (dto: server.dto.ResendParticipantEmailInstruction) => ["InvoiceV2.ResendParticipantEmail", dto]
  }, 
  ListActivity: {
    useQuery: (dto: server.dto.PaginatedItemActivityInstruction, opts: UseQueryOptions<server.dto.ApiResponseWrapper<server.dto.InvoiceActivity[]>>) => useQuery({
      queryKey: ["InvoiceV2.ListActivity", dto],
      queryFn: () => window.CoreApi.InvoiceV2.ListActivity(dto).then(r => r.data),
      ...opts
    }),
    getCacheKey: (dto: server.dto.PaginatedItemActivityInstruction) => ["InvoiceV2.ListActivity", dto]
  }, 
  ListReminders: {
    useQuery: (invoiceId: number, opts: UseQueryOptions<server.dto.ApiResponseWrapper<server.dto.InvoiceReminder[]>>) => useQuery({
      queryKey: ["InvoiceV2.ListReminders", invoiceId],
      queryFn: () => window.CoreApi.InvoiceV2.ListReminders(invoiceId).then(r => r.data),
      ...opts
    }),
    getCacheKey: (invoiceId: number) => ["InvoiceV2.ListReminders", invoiceId]
  }, 
  DeleteAllReminders: {
    useQuery: (invoiceId: number, opts: UseQueryOptions<server.dto.ApiResponse>) => useQuery({
      queryKey: ["InvoiceV2.DeleteAllReminders", invoiceId],
      queryFn: () => window.CoreApi.InvoiceV2.DeleteAllReminders(invoiceId).then(r => r.data),
      ...opts
    }),
    getCacheKey: (invoiceId: number) => ["InvoiceV2.DeleteAllReminders", invoiceId]
  }, 
  DeleteLastReminder: {
    useQuery: (invoiceId: number, opts: UseQueryOptions<server.dto.ApiResponse>) => useQuery({
      queryKey: ["InvoiceV2.DeleteLastReminder", invoiceId],
      queryFn: () => window.CoreApi.InvoiceV2.DeleteLastReminder(invoiceId).then(r => r.data),
      ...opts
    }),
    getCacheKey: (invoiceId: number) => ["InvoiceV2.DeleteLastReminder", invoiceId]
  }, 
  AddReminder: {
    useQuery: (dto: server.dto.AddInvoiceReminderInstruction, opts: UseQueryOptions<server.dto.ApiResponse>) => useQuery({
      queryKey: ["InvoiceV2.AddReminder", dto],
      queryFn: () => window.CoreApi.InvoiceV2.AddReminder(dto).then(r => r.data),
      ...opts
    }),
    getCacheKey: (dto: server.dto.AddInvoiceReminderInstruction) => ["InvoiceV2.AddReminder", dto]
  }, 
  UpdateReminder: {
    useQuery: (dto: server.dto.UpdateInvoiceReminderInstruction, opts: UseQueryOptions<server.dto.ApiResponse>) => useQuery({
      queryKey: ["InvoiceV2.UpdateReminder", dto],
      queryFn: () => window.CoreApi.InvoiceV2.UpdateReminder(dto).then(r => r.data),
      ...opts
    }),
    getCacheKey: (dto: server.dto.UpdateInvoiceReminderInstruction) => ["InvoiceV2.UpdateReminder", dto]
  }, 

}
